import {useEffect, useState} from "react";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {useParams} from "react-router-dom";
import {useGetAppraisalRollByIdQuery} from "../appraisalRollsApi";
import {useGetCollectorByIdQuery} from "../../collector/collector";
import {formatValueAsDateAndTime} from "../../../../helpers/utils/DateUtils";
import Preloader from "../../../../components/common/Preloader";

const AppraisalRollDetailPage = () => {

    let {appraisalRollId} = useParams();
    const [collectorId, setCollectorId] = useState(null);

    const [crumbs] = useState([
            {content: "Home", url: "/home"},
            {content: "Appraisal Roll", url: "/appraisal-rolls"},
            {content: "", url: ""}
        ]
    )
    const appraisalRollByIdApi = useGetAppraisalRollByIdQuery(appraisalRollId);
    const {data: collectorData} = useGetCollectorByIdQuery(collectorId, {
        skip: !collectorId,
    });
    useEffect(() => {
        if (appraisalRollByIdApi?.data) {
            crumbs[crumbs.length - 1].content = appraisalRollByIdApi.data.taxAccountNumber;
            setCollectorId(appraisalRollByIdApi.data.collectorId);
        }
    }, [appraisalRollByIdApi]);

    return (
        <>
            {appraisalRollByIdApi.data === undefined || appraisalRollByIdApi?.data?.id === undefined
                ? <Preloader/>
                :
            <div className="px-4 py-2">

                <div className={"justify-between sm:block md:flex lg:flex"}>
                    <Breadcrumb crumbs={crumbs}/>
                </div>

                <div className="flex justify-center mt-3">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-7 mb-4">Appraisal
                            Details</h3>

                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Key Id
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="keyId"
                                    value={appraisalRollByIdApi?.data?.keyId}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Collector
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="collector"
                                    value={collectorData?.name}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Source File Id
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="sourceFileId"
                                    value={appraisalRollByIdApi?.data?.sourceFileId}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Tax Account No.
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="taxAccountNumber"
                                    value={appraisalRollByIdApi?.data?.taxAccountNumber}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Geo Id
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="geographicId"
                                    value={appraisalRollByIdApi?.data?.geographicId}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Tax Year
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="taxYear"
                                    value={appraisalRollByIdApi?.data?.taxYear}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Property Type
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="propertyType"
                                    value={appraisalRollByIdApi?.data?.propertyType}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Situs Address
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="situsAddress"
                                    value={appraisalRollByIdApi?.data?.situsAddress}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Legal Description
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="legalDescription"
                                    value={appraisalRollByIdApi?.data?.legalDescription}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Deed Date
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="deedDate"
                                    value={appraisalRollByIdApi?.data?.deedDate ?? formatValueAsDateAndTime(appraisalRollByIdApi?.data?.deedDate)}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Deed Book
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="deedBook"
                                    value={appraisalRollByIdApi?.data?.deedBook}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Deed Page
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="deedPage"
                                    value={appraisalRollByIdApi?.data?.deedPage}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Lot Size
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="logSize"
                                    value={appraisalRollByIdApi?.data?.lotSize}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Land Value
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="landValue"
                                    value={appraisalRollByIdApi?.data?.landValue}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Improvement Value
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="improvementValue"
                                    value={appraisalRollByIdApi?.data?.improvementValue}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Agricultural Value
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="agriculturalValue"
                                    value={appraisalRollByIdApi?.data?.agriculturalValue}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Has Multiple Owners?
                            </label>
                            <div className="w-full sm:w-8/12">
                            <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="agriculturalValue"
                                    value={appraisalRollByIdApi?.data?.hasMultipleOwners}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Owner Name
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="ownerName"
                                    value={appraisalRollByIdApi?.data?.ownerName}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Owner Address
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="ownerAddress"
                                    value={appraisalRollByIdApi?.data?.ownerAddress}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Jurisdictions
                            </label>
                            <div className="w-full sm:w-8/12">
                                 <textarea
                                     className=" w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                     name="jurisdictions"
                                     value={appraisalRollByIdApi?.data?.jurisdictions?.join(", ")}
                                     required={true} disabled={true}/>

                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Exemptions
                            </label>
                            <div className="w-full sm:w-8/12">
                                 <textarea
                                     className=" w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                     name="jurisdictions"
                                     value= {appraisalRollByIdApi.data?.exemptions?.map((curExemp: any, i: any) =>
                                         appraisalRollByIdApi.data.exemptions.length - 1 === i ? curExemp : curExemp + ","
                                     )}
                                     required={true} disabled={true}/>

                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Private Owner?
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="privateOwner"
                                    value={appraisalRollByIdApi?.data?.privateOwner}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Certified?
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="certified"
                                    value={appraisalRollByIdApi?.data?.certified}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Subdivision Name
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="subdivisionName"
                                    value={appraisalRollByIdApi?.data?.subdivisionName}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-center sm:items-start mb-3">
                            <label htmlFor="collector" className="w-full sm:w-4/12 text-sm font-medium text-text-7">
                                Subdivision Code
                            </label>
                            <div className="w-full sm:w-8/12">
                                <input
                                    className="w-full px-3 py-2 border border-surface-5 rounded-md bg-surface-5 text-text-6 cursor-not-allowed"
                                    type="text"
                                    name="subdivisionCode"
                                    value={appraisalRollByIdApi?.data?.subdivisionCode}
                                    placeholder="-"
                                    autoComplete="off"
                                    required
                                    disabled
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            }
        </>
    )
}
export default AppraisalRollDetailPage;